import { defineComponent as n, openBlock as a, createBlock as r, unref as c, mergeProps as p, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconBellDisabled",
  __name: "IconBellDisabled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (a(), r(c(d), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M12 2.125c-1.774 0-3.485.657-4.755 1.842a5.5 5.5 0 0 0-.932 1.16L3.53 2.345a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-2.72-2.72h.69a1.25 1.25 0 0 0 1.25-1.25v-.136c0-.547-.343-.963-.708-1.17-.388-.22-1.292-.899-1.292-2.694v-3.5c0-1.646-.687-3.687-1.995-4.908-1.27-1.184-2.982-1.842-4.755-1.842m5.31 14L7.415 6.228A4.3 4.3 0 0 1 8.27 5.064C9.25 4.147 10.592 3.625 12 3.625s2.749.523 3.731 1.439c.942.879 1.519 2.487 1.519 3.811v3.5c0 2.073.933 3.196 1.673 3.75h-1.612",
          "clip-rule": "evenodd"
        }, null, -1),
        l("path", { d: "m14.59 17.625-1.5-1.5H5.101c.744-.553 1.648-1.668 1.648-3.75v-2.59L5.276 8.312A6 6 0 0 0 5.25 8.875v3.5c0 1.836-.893 2.485-1.268 2.69C3.61 15.27 3.25 15.69 3.25 16.253v.123a1.25 1.25 0 0 0 1.25 1.25h10.09m-3.83 1.656a.75.75 0 0 0-1.489.186 2.75 2.75 0 0 0 5.458 0 .75.75 0 1 0-1.489-.186 1.25 1.25 0 0 1-2.48 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
